import { useMemo } from "react";
import difference from "lodash/difference";
import { t } from "@/i18n-js/instance";
import { toQueryString } from "@/react/helpers/urlHelpers";
import { useRouterQueryParams } from "@/react/hooks/useRouterQueryParams";

export const SORT_TYPES = [
  "latest",
  "new_activity",
  "oldest",
  "popular",
  "likes",
  "alphabetical",
];

export const useSortBy = ({
  defaultSort = "latest",
  include = SORT_TYPES,
  exclude = [],
}: {
  defaultSort: string;
  include?: string[];
  exclude?: string[];
}) => {
  const defaultValue = SORT_TYPES.includes(defaultSort)
    ? defaultSort
    : include[0];
  const { sort = defaultValue, ...rest } = useRouterQueryParams();

  const sortingOptions = useMemo(() => {
    const availableSortTypes = difference(include, exclude);
    // eslint-disable-next-line no-param-reassign -- Disabled for TypeScript v5 update. Fix when possible.
    defaultSort = defaultSort ?? availableSortTypes[0];
    return availableSortTypes.map(sortType => ({
      value: sortType,
      label: t(`sorting_options.${sortType}`),
      pathTo: `?${toQueryString({ ...rest, sort: sortType })}`,
    }));
  }, [defaultSort, include, exclude, rest, sort]);

  return {
    sort,
    sortingOptions,
  };
};
